import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  pl: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        about: 'O nas',
        services: 'Usługi',
        contact: 'Kontakt',
        blog: 'Blog'
      },
      // Hero
      hero: {
        badge: 'Data & Analytics Excellence',
        title1: 'Beyond Data.',
        title2: 'The Future is Light.',
        description: 'Przekształcamy surowe dane w strategiczne przewagi. Specjalizujemy się w zaawansowanej analityce i rozwiązaniach Data & Analytics dla przedsiębiorstw.',
        cta1: 'Odkryj nasze usługi',
        cta2: 'Porozmawiajmy',
        scroll: 'Scroll'
      },
      // Services
      services: {
        label: 'Nasze usługi',
        title1: 'Rozwiązania, które',
        title2: 'się sprawdzają',
        description: 'Dostarczamy kompleksowe rozwiązania Data & Analytics, które pomagają firmom podejmować lepsze decyzje.',
        service1: {
          title: 'Intelligent Insights',
          description: 'Odkrywaj ukryte wzorce w danych dzięki zaawansowanej analityce i uczeniu maszynowemu.'
        },
        service2: {
          title: 'Seamless Integration',
          description: 'Bezproblemowa integracja systemów i danych z różnych źródeł w jedno spójne środowisko.'
        },
        service3: {
          title: 'Sustainable Growth',
          description: 'Budujemy skalowalne rozwiązania wspierające długoterminowy rozwój Twojego biznesu.'
        },
        service4: {
          title: 'Presales Consulting',
          description: 'Profesjonalne wsparcie w procesach presales i zarządzanie ofertowaniem dla projektów Data & Analytics.'
        }
      },
      // About
      about: {
        label: 'O nas',
        title1: 'Limitless Solutions –',
        title2: 'Twój partner w świecie danych',
        description: 'Jesteśmy zespołem ekspertów specjalizujących się w transformacji danych w wartość biznesową. Łączymy zaawansowaną technologię z głębokim zrozumieniem potrzeb biznesowych, dostarczając rozwiązania, które naprawdę działają.',
        learnMore: 'Dowiedz się więcej',
        stats: {
          projects: 'Zrealizowanych projektów',
          clients: 'Zadowolonych klientów',
          experience: 'Lat doświadczenia',
          satisfaction: 'Satysfakcji klientów'
        }
      },
      // Contact
      contact: {
        label: 'Kontakt',
        title1: 'Porozmawiajmy',
        title2: 'o Twoim projekcie',
        description: 'Skontaktuj się z nami, aby dowiedzieć się, jak możemy pomóc Twojej firmie wykorzystać pełny potencjał danych.',
        email: 'Email',
        phone: 'Telefon',
        form: {
          name: 'Imię i nazwisko',
          namePlaceholder: 'Jan Kowalski',
          company: 'Firma',
          companyPlaceholder: 'Nazwa firmy',
          emailLabel: 'Email',
          emailPlaceholder: 'jan@firma.pl',
          message: 'Wiadomość',
          messagePlaceholder: 'Opisz swój projekt lub pytanie...',
          submit: 'Wyślij wiadomość',
          sending: 'Wysyłanie...',
          success: 'Dziękujemy!',
          successMsg: 'Twoja wiadomość została wysłana. Skontaktujemy się wkrótce.',
          error: 'Błąd wysyłania',
          errorMsg: 'Przepraszamy, wystąpił problem. Spróbuj ponownie lub napisz bezpośrednio na email.',
          retry: 'Spróbuj ponownie'
        }
      },
      // Chatbot
      chatbot: {
        title: 'Asystent D&A',
        subtitle: 'Limitless Solutions',
        placeholder: 'Zapytaj o Data & Analytics...',
        welcome: 'Cześć! Jestem asystentem Limitless Solutions. Jak mogę Ci pomóc w zakresie Data & Analytics?\n\nMożesz zapytać mnie o:\n• Nasze usługi (Business Intelligence, ML, Cloud Analytics)\n• Procesy integracji danych\n• Rozwiązania dla Twojego biznesu',
        clearChat: 'Wyczyść rozmowę',
        error: 'Przepraszam, wystąpił błąd. Spróbuj ponownie lub skontaktuj się z nami przez formularz.'
      },
      // Footer
      footer: {
        description: 'Przekształcamy surowe dane w strategiczne przewagi. Specjalizujemy się w zaawansowanej analityce i rozwiązaniach Data & Analytics.',
        navigation: 'Nawigacja',
        contact: 'Kontakt',
        rights: 'Wszelkie prawa zastrzeżone.'
      },
      // Blog
      blog: {
        title: 'Insights & Analizy',
        description: 'Najnowsze artykuły o Data & Analytics, Machine Learning i nowoczesnych technologiach.',
        noPosts: 'Brak opublikowanych artykułów.',
        addFirst: 'Dodaj pierwszy artykuł',
        admin: 'Panel administracyjny',
        backToBlog: 'Wróć do bloga',
        backToAll: 'Wróć do wszystkich artykułów',
        share: 'Udostępnij',
        notFound: 'Artykuł nie został znaleziony'
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        contact: 'Contact',
        blog: 'Blog'
      },
      // Hero
      hero: {
        badge: 'Data & Analytics Excellence',
        title1: 'Beyond Data.',
        title2: 'The Future is Light.',
        description: 'We transform raw data into strategic advantages. We specialize in advanced analytics and Data & Analytics solutions for enterprises.',
        cta1: 'Discover our services',
        cta2: "Let's talk",
        scroll: 'Scroll'
      },
      // Services
      services: {
        label: 'Our services',
        title1: 'Solutions that',
        title2: 'deliver',
        description: 'We deliver comprehensive Data & Analytics solutions that help companies make better decisions.',
        service1: {
          title: 'Intelligent Insights',
          description: 'Discover hidden patterns in data through advanced analytics and machine learning.'
        },
        service2: {
          title: 'Seamless Integration',
          description: 'Seamless integration of systems and data from various sources into one cohesive environment.'
        },
        service3: {
          title: 'Sustainable Growth',
          description: 'We build scalable solutions supporting long-term growth of your business.'
        },
        service4: {
          title: 'Presales Consulting',
          description: 'Professional support in presales processes and bid management for Data & Analytics projects.'
        }
      },
      // About
      about: {
        label: 'About us',
        title1: 'Limitless Solutions –',
        title2: 'Your partner in the world of data',
        description: 'We are a team of experts specializing in transforming data into business value. We combine advanced technology with deep understanding of business needs, delivering solutions that truly work.',
        learnMore: 'Learn more',
        stats: {
          projects: 'Completed projects',
          clients: 'Satisfied clients',
          experience: 'Years of experience',
          satisfaction: 'Client satisfaction'
        }
      },
      // Contact
      contact: {
        label: 'Contact',
        title1: "Let's talk",
        title2: 'about your project',
        description: 'Contact us to find out how we can help your company unlock the full potential of data.',
        email: 'Email',
        phone: 'Phone',
        form: {
          name: 'Full name',
          namePlaceholder: 'John Smith',
          company: 'Company',
          companyPlaceholder: 'Company name',
          emailLabel: 'Email',
          emailPlaceholder: 'john@company.com',
          message: 'Message',
          messagePlaceholder: 'Describe your project or question...',
          submit: 'Send message',
          sending: 'Sending...',
          success: 'Thank you!',
          successMsg: 'Your message has been sent. We will contact you soon.',
          error: 'Sending error',
          errorMsg: 'Sorry, there was a problem. Please try again or email us directly.',
          retry: 'Try again'
        }
      },
      // Chatbot
      chatbot: {
        title: 'D&A Assistant',
        subtitle: 'Limitless Solutions',
        placeholder: 'Ask about Data & Analytics...',
        welcome: "Hi! I'm the Limitless Solutions assistant. How can I help you with Data & Analytics?\n\nYou can ask me about:\n• Our services (Business Intelligence, ML, Cloud Analytics)\n• Data integration processes\n• Solutions for your business",
        clearChat: 'Clear conversation',
        error: 'Sorry, an error occurred. Please try again or contact us via the form.'
      },
      // Footer
      footer: {
        description: 'We transform raw data into strategic advantages. We specialize in advanced analytics and Data & Analytics solutions.',
        navigation: 'Navigation',
        contact: 'Contact',
        rights: 'All rights reserved.'
      },
      // Blog
      blog: {
        title: 'Insights & Analysis',
        description: 'Latest articles about Data & Analytics, Machine Learning and modern technologies.',
        noPosts: 'No published articles.',
        addFirst: 'Add first article',
        admin: 'Admin panel',
        backToBlog: 'Back to blog',
        backToAll: 'Back to all articles',
        share: 'Share',
        notFound: 'Article not found'
      }
    }
  }
};

// Get saved language or detect from browser
const getSavedLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  const saved = localStorage.getItem('language');
  if (saved) return saved;
  
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'pl' ? 'pl' : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
